import styled from "styled-components";

export const HeroImage = styled.img<{ $position?: string }>`
  object-fit: cover;
  height: 285px;
  width: 100%;
  object-position: ${({ $position }) => $position ?? "initial"};
`;
